import { render, staticRenderFns } from "./BatchJoin.vue?vue&type=template&id=749c0a8a"
import script from "./BatchJoin.vue?vue&type=script&lang=js"
export * from "./BatchJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749c0a8a')) {
      api.createRecord('749c0a8a', component.options)
    } else {
      api.reload('749c0a8a', component.options)
    }
    module.hot.accept("./BatchJoin.vue?vue&type=template&id=749c0a8a", function () {
      api.rerender('749c0a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/BatchJoin.vue"
export default component.exports